<!-- Created by henian.xu on 2018/2/27. -->

<template>
    <div 
        :class="['switch',value?'open':'close']"
        @click="onClick"
    >
        <div class="dot"/>
    </div>
</template>

<script>
import { formMixin } from '../mixins';

export default {
    name: 'XSwitch',
    mixins: [formMixin],
    data() {
        return {};
    },
    props: {
        value: {
            type: Boolean,
            default() {
                return false;
            },
        },
    },
    methods: {
        onClick() {
            const { disabled_, readonly_ } = this;
            if (disabled_ || readonly_) return;
            this.$emit('input', !this.value);
        },
    },
};
</script>

<style lang="scss">
.switch {
    position: relative;
    display: inline-block;
    width: $formItemHeight * 2;
    height: $formItemHeight;
    border-radius: 100vw;
    border: 1px solid $color-border;
    background-color: $gray6;
    > .dot {
        position: absolute;
        top: -1px;
        left: -1px;
        width: $formItemHeight;
        height: $formItemHeight;
        background-color: #fff;
        border: 1px solid $color-border;
        border-radius: 50%;
    }

    &.close {
        background-color: #fff;
    }
    &.open {
        background-color: $color-main;
        border-color: $color-main;
        > .dot {
            border-color: $color-main;
            left: auto;
            right: -1px;
        }
    }
}
</style>
